export default {
  colors: {
    background: "#f8f8ff",
    primary: "#2563eb"
  }
}